import { 
  SET_ADD_IN_PROCESS_NEW_DSR_POST, 
  SET_ADDED_PROCESSING_DSR_POST, 
  SET_REMOVE_IN_PROCESS_NEW_DSR_POST, 
  SET_REMOVED_PROCESSING_DSR_POST 
} from '../../actions/dsr-ux-actions-types';

const INITIAL_STATE_DSR_PROCESSING_POSTS = { results: [] }

export function setProcessingDsrPostsReducer(state = INITIAL_STATE_DSR_PROCESSING_POSTS, action) {
  switch (action.type) {
    case SET_ADDED_PROCESSING_DSR_POST:
      return {
        ...state,
        results: [...state.results, action.payload]
      };
    case SET_REMOVED_PROCESSING_DSR_POST:
      return {
        ...state,
        results: state.results.filter(id => id !== action.payload)
      };
    default:
      return state;
  }
}

const INITIAL_STATE_NEW_DSR_POSTS_PROCESSING = { results: [] }

export function setProcessingNewDsrPostsReducer(state = INITIAL_STATE_NEW_DSR_POSTS_PROCESSING, action) {
  switch (action.type) {
    case SET_ADD_IN_PROCESS_NEW_DSR_POST:
      return {
        ...state,
        results: [...state.results, action.payload]
      };
    case SET_REMOVE_IN_PROCESS_NEW_DSR_POST:
      return {
        ...state,
        results: state.results.filter(id => id !== action.payload)
      };
    default:
      return state;
  }
}